import { Pipe, PipeTransform } from '@angular/core';
import { CommonProvider } from '../../providers/common/common';

@Pipe({
  name: 'title',
})
export class TitlePipe implements PipeTransform {
  constructor(
    public comProv: CommonProvider
  ){}

  transform(page: string) {
    let title = '';
    let drawer_list = this.comProv.getDrawer();
    if (drawer_list.length > 0) {
      let drawer_data = drawer_list.find(element => element['page_target'] == page);
      if (drawer_data) {
        title = drawer_data['title'];
      }
    }

    return title;
  }
}


// WEBPACK FOOTER //
// ./src/pipes/title/title.ts